// @ts-nocheck

import React, { useEffect, useRef } from 'react';
import { Box, Text } from "@primer/react";
import { useTranslation } from 'react-i18next';
import { Button, Link } from '@fluentui/react-components';

const Footer = () => {
    const { t } = useTranslation();
    const siteConsentRef = useRef(null);

    useEffect(() => {

        window.insertClarity = () => {
            const script = document.createElement('script');
            const scriptNode = document.createTextNode((function (c, l, a, r, i, t, y) {
                c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
                t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
                y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
            })(window, document, "clarity", "script", "phtjmyp391"));
            script.appendChild(scriptNode);
            script.type = 'text/javascript';
            document.body.appendChild(script);

            if (window.clarity) {
                window.clarity('consent');
            }
        };

        window.onConsentChanged = (categoryPreferences) => {
            const { Analytics } = categoryPreferences;

            if (Analytics) {
                console.log("Consent for Analytics is accepted");
                if (window.clarity) {
                    window.clarity('start');
                } else {
                    window.insertClarity();
                }
            } else {
                console.log("Consent for Analytics is rejected");
                if (window.clarity) {
                    window.clarity('stop');
                }
            }
        }

        if (window.WcpConsent) {
            window.WcpConsent.init(navigator.language, "cookie-banner", function (err, _siteConsent) {
                if (!err) {
                    siteConsentRef.current = _siteConsent;  // 使用 useRef 保存 siteConsent 的值

                    // attach manage consent functionality
                    function manageConsent() {
                        if (siteConsentRef.current.isConsentRequired) {
                            siteConsentRef.current.manageConsent();
                        }
                    }

                    const manageConsentButton = document.getElementById("manageConsentButton");
                    if (manageConsentButton) {
                        manageConsentButton.addEventListener('click', manageConsent);
                        if (!siteConsentRef.current.isConsentRequired) {
                            manageConsentButton.style.display = "none";
                        }
                    } else {
                        console.log("No manage consent button found");
                    }
                } else {
                    console.log("Error initializing WcpConsent: " + err);
                }
            }, onConsentChanged);
        }

        if (siteConsentRef.current && siteConsentRef.current.getConsentFor("Analytics")) {
            console.log("Consent for Analytics is given");
            window.insertClarity();
        }
    }, []);

    return (
        <>
            <footer>
                <Box
                    sx={{
                        borderTopWidth: 1,
                        borderTopStyle: 'solid',
                        borderColor: 'border.default',
                        p: 3,
                    }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Text as="p" sx={{ color: 'fg.default' }}>
                            Made with ❤️ by <Link href="https://caozhi.li" target="_blank">Caozhi Li</Link>
                        </Text>
                        <Button id="manageConsentButton" appearance="subtle">{t('manage_cookies')}</Button>
                    </Box>
                </Box>
            </footer>
        </>
    );
}

export default Footer;
